<section class="portal-detail-section">
  <button
    type="button"
    class="portal-detail-section__heading"
    [class.collapsed]="!open"
    (click)="toggle.emit()">
    <mat-icon>expand_more</mat-icon>
    <span>{{ title }}</span>
    <ng-content select="[portalDetailSectionMeta]"></ng-content>
  </button>

  <div class="portal-detail-section__content" *ngIf="open">
    <ng-content></ng-content>
  </div>
</section>
